import React from 'react';

const PurePromoLogo = ({ subtitle = false, size = 'md' }) => {
  const sizes = {
    sm: { word: 'text-[18px]', sub: 'text-[9px]' },
    md: { word: 'text-[22px]', sub: 'text-[10px]' },
    lg: { word: 'text-[28px]', sub: 'text-[11px]' }
  }[size];

  return (
    <div className="inline-flex flex-col select-none">
      <div className={`font-black tracking-tight ${sizes.word} leading-none`}>
        <span className="text-[#111111]">PURE</span>
        <span className="text-[#6E56E7]">PROMO</span>
      </div>
      {subtitle && (
        <div className={`mt-1.5 ${sizes.sub} font-semibold tracking-[0.22em] text-slate-500`}>
          TELEKOMMUNIKATION. PROMOTION. VERTRIEB.
        </div>
      )}
    </div>
  );
};

export default PurePromoLogo;
